const $inject = ['$http', '$q', 'moment', 'userProfileService', 'apiService'];

const userPeopleService = ($http, $q, moment, userProfileService, apiService) => {
  const service = {
    getPeople: getPeople,
    getPerson: getPerson,
    updatePerson: updatePerson,
    people: []
  };

  return service;

  function getPeople() {
    const apiUrl = apiService.getUrl('userPeople', { debtorId: userProfileService.profile.DebtorIdentifier });

    return $http.get(apiUrl)
      .then((res) => {
        let data = res.data;
        service.people = data;
      })
      .catch(() => {

      });
  }

  function getPerson(id) {
    const deferred = $q.defer();
    const person = _.find(service.people, { Id : id });

    if (person) {
      deferred.resolve(person);
    } else {
      const apiUrl = apiService.getUrl('userPeople', {
        debtorId: userProfileService.profile.DebtorIdentifier,
        id: id
      });

      $http.get(apiUrl)
        .then((response) => {
          deferred.resolve(response.data);
        })
        .catch(() => {
          deferred.reject();
        });
    }

    return deferred.promise;
  }

  function updatePerson(person) {
    let deferred = $q.defer();

    const apiUrl = apiService.getUrl('userPeople', {
      debtorId: userProfileService.profile.DebtorIdentifier,
      id: person.Id
    });

    $http.put(apiUrl, person)
      .then((response) => {
        deferred.resolve(response.data);
      })
      .catch(() => {
        deferred.reject();
      });

    return deferred.promise;
  }
};

userPeopleService.$inject = $inject;

export default userPeopleService;


// WEBPACK FOOTER //
// ./src/services/userPeopleService.js